import styled from 'styled-components';

export const SuccessInfoStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${({ theme }) => theme.UI_COLORS.light};
  text-align: center;
  padding: 3rem;
  border-radius: 1rem;
  font-size: 2rem;
  position: relative;

  & > .closeIcon {
    position: absolute;
    top: 1rem;
    right: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3px;
    border: 1px solid ${({ theme }) => theme.UI_COLORS.medium_gray};
    border-radius: 50%;
    cursor: pointer;

    svg {
      fill: ${({ theme }) => theme.UI_COLORS.medium_gray};
    }
  }

  & > p {
    span.bold {
      font-weight: bold;
    }
    padding: 0 5px;
  }

  & > img {
    display: block;
  }

  & > .bottomText {
    font-size: ${({ theme }) => theme.TYPOGRAPHY.bodyTextSmall.fontSize};
    font-weight: ${({ theme }) => theme.TYPOGRAPHY.bodyTextSmall.fontWeight};
    margin-bottom: 1rem;
    margin-top: 1.5rem;

    & > .clickable {
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;
